<div style="background-color: #F5F7F8; height: 100vh; overflow-y: scroll; padding: 10px; padding-top: 20px;">
    <img style="width: 22px; height: 22px; position: absolute; top: 25px; left: 20px;" (click)="this.back()" src="/assets/images/shared/back.svg">
    <h2 style="text-align: center;">Данни за доставка</h2>
    <div style="height: 76vh; overflow-y: scroll; margin-bottom: 5px;">

        <div style="width: 90%; margin: auto; background-color: #E4F2FE; margin-top: 10px; border-radius: 10px; padding: 10px;">
            <div class="row">
                <div class="col-3">
                    <img src="/assets/images/orders/logo-speedy.svg" style="position: relative; left: 5px; margin-right: 5px; width: 80%; position: relative; top: -10px;" alt="">
                    <div style="position: relative; left: 15px; display: inline-block; border-left: 1px solid #ADAFBB; height: 60%; margin-top: 20%;"></div>
                </div>
                <p class="col-9" style="position: relative; top: 5px; font-weight: 500;">
                    Доставките се извършват само с куриерска фирма Speedy
                </p>
            </div>

        </div>
        <div style="width: 90%; margin: auto; background-color: white; margin-top: 10px; border-radius: 10px; padding: 10px;">
            <p>Доставка</p>
            <div data-bs-toggle="offcanvas" *ngIf="!this.order!.toCarrierOffice" (click)="this.open(address)" aria-controls="offcanvasBottom">
                <img style="width: 44px; height: 44px; margin: 5px;" src="/assets/images/shared/icon-address.png" alt="">
                <p style="display: inline-block; width: 70%; margin: 5px;">Доставка до адрес</p>
                <img style="width: 10px; height: 10px; margin: 5px;" src="/assets/images/shared/down-tap.svg" alt="">
            </div>
            <div data-bs-toggle="offcanvas" *ngIf="this.order!.toCarrierOffice" (click)="this.open(address)" aria-controls="offcanvasBottom">
                <img style="width: 44px; height: 44px; margin: 5px;" src="/assets/images/shared/delivery-courier.png" alt="">
                <p style="display: inline-block; width: 70%; margin: 5px;">{{this.pageDetails().office}}</p>
                <img style="width: 10px; height: 10px; margin: 5px;" src="/assets/images/shared/down-tap.svg" alt="">
            </div>
            <hr style="width: 90%; margin: auto; border: 1px solid #F5F7F8; opacity: 1; margin-top: 10px; margin-bottom: 10px;">
            <div (click)="this.cooseAddress()" *ngIf="(!this.order?.contactUUID && this.order?.toAddress) || (!this.order?.carrierOfficeAddress && this.order?.toCarrierOffice)">
                <img style="width: 44px; height: 44px; margin: 5px;" src="/assets/images/shared/add-account.png" alt="">
                <p style="display: inline-block; width: 50%; margin: 5px;">Добави адрес</p>
            </div>
            <div *ngIf="this.order?.contactUUID && this.order?.toAddress" style="display: flex; align-items: center;">
                <img style="width: 44px; height: 44px; margin: 5px;" src="/assets/images/shared/icon-address.png" alt="">
                <p style="display: inline-block; width: 50%; margin: 5px;">
                    <span style="margin-bottom: 5px;"> {{  this.order?.addressName }} </span><br>
                    <span style="margin-bottom: 5px;"> {{  this.order?.phone }} </span><br>
                    {{  this.getAddressString() }}
                </p>
                <button (click)="this.cooseAddress()" type="button" class="btn" style=" font-size: 14px; color: #007bff">Промени</button>
            </div>
            <div *ngIf="this.order?.carrierOfficeAddress && this.order?.toCarrierOffice" style="display: flex; align-items: center;">
                <img style="width: 44px; height: 44px; margin: 5px;" src="/assets/images/shared/delivery-courier.png" alt="">
                <p style="display: inline-block; width: 50%; margin: 5px;">
                    <span style="margin-bottom: 5px;"> {{  this.order?.carrierOfficeName  }} </span><br>
                    <span style="margin-bottom: 5px;"> {{  this.order?.carrierOfficePhone }} </span><br>
                    {{ this.order?.carrierOfficeAddress }}
                </p>
                <button (click)="this.cooseAddress()" type="button" class="btn" style=" font-size: 14px; color: #007bff">Промени</button>
            </div>
        </div>

        <div style="width: 90%; margin: auto; background-color: white; margin-top: 10px; border-radius: 10px; padding: 10px;" *ngIf="(this.order?.contactUUID && this.order?.toAddress) || (this.order?.carrierOfficeAddress && this.order?.toCarrierOffice)">
            <input style="width: 20px; height: 20px; margin: 5px; position: relative;" class="form-check-input" type="checkbox" [value]="false" id="flexCheckDefault" [checked]="!this.order?.isNewInvoiceAddress" (change)="this.toggleSameInvoice($event)">
            <span (click)="this.toggleSameInvoice($event)" style="font-weight: 500; font-size: 11px; position: relative; top: 4px;">Използвай същия адрес за фактуриране</span>
            <div  *ngIf="this.order?.isNewInvoiceAddress && !this.order?.invoiceContactUUID" (click)="this.cooseInvoiceAddress()" style="display: flex; align-items: center; margin-top: 5px;">
                <img style="width: 44px; height: 44px; margin: 5px;" src="/assets/images/shared/add-account.png" alt="">
                <p style="display: inline-block; width: 50%; margin: 5px;">Добави адрес</p>
            </div>
            <div *ngIf="this.order?.isNewInvoiceAddress && this.order?.invoiceContactUUID" style="display: flex; align-items: center; margin-top: 5px;">
                <img style="width: 44px; height: 44px; margin: 5px;" src="/assets/images/shared/icon-invoice-address.svg" alt="">
                <p style="display: inline-block; width: 50%; margin: 5px;">
                    <span style="margin-bottom: 5px;"> {{  this.order?.invoiceAddressName }} </span><br>
                    <span style="margin-bottom: 5px;"> {{  this.order?.invoicePhone }} </span><br>
                    {{  this.getInvoiceAddressString() }}
                </p>
                <button (click)="this.cooseInvoiceAddress()" type="button" class="btn" style=" font-size: 14px; color: #007bff">Промени</button>
            </div>
            <!-- <div *ngIf="!this.order?.isNewInvoiceAddress && this.order?.toAddress" style="display: flex; align-items: center;">
                <img style="width: 44px; height: 44px; margin: 5px;" src="/assets/images/shared/icon-address.png" alt="">
                <p style="display: inline-block; width: 50%; margin: 5px;">
                    <span style="margin-bottom: 5px;"> {{  this.order?.addressName  }} </span><br>
                    <span style="margin-bottom: 5px;"> {{  this.order?.phone }} </span><br>
                    {{  this.getAddressString() }}
                </p>
            </div>
            <div *ngIf="!this.order?.isNewInvoiceAddress && this.order?.toCarrierOffice" style="display: flex; align-items: center;">
                <img style="width: 44px; height: 44px; margin: 5px;" src="/assets/images/shared/icon-address.png" alt="">
                <p style="display: inline-block; width: 50%; margin: 5px;">
                    <span style="margin-bottom: 5px;"> {{  this.order?.carrierOfficeName  }} </span><br>
                    <span style="margin-bottom: 5px;"> {{  this.order?.carrierOfficePhone }} </span><br>
                    {{ this.order?.carrierOfficeAddress }}
                </p>
            </div> -->
        </div>

        <div style="width: 90%; margin: auto; background-color: white; margin-top: 10px; border-radius: 10px; padding: 10px;">
            <p>Плащане</p>
            <div  data-bs-toggle="offcanvas" *ngIf="!this.order!.cardPayment" (click)="this.open(payments)" aria-controls="offcanvasBottom">
                <img style="width: 44px; height: 44px; margin: 5px;" src="/assets/images/shared/icon-cash-on-delivery.png" alt="">
                <p style="display: inline-block; width: 70%; margin: 5px;">{{this.pageDetails().cod}}</p>
                <img style="width: 10px; height: 10px; margin: 5px;" src="/assets/images/shared/down-tap.svg" alt="">
            </div>
            <div  data-bs-toggle="offcanvas" *ngIf="this.order!.cardPayment" (click)="this.open(payments)" aria-controls="offcanvasBottom">
                <img style="width: 44px; height: 44px; margin: 5px;" src="/assets/images/shared/icon-card.png" alt="">
                <p style="display: inline-block; width: 70%; margin: 5px;">{{this.pageDetails().card}}</p>
                <img style="width: 10px; height: 10px; margin: 5px;" src="/assets/images/shared/down-tap.svg" alt="">
            </div>
            <hr style="width: 90%; margin: auto; border: 1px solid #F5F7F8; opacity: 1; margin-top: 10px; margin-bottom: 10px;">
            <div *ngIf="!this.order?.paymentCard && this.order?.cardPayment" (click)="this.cooseCard()">
                <img style="width: 44px; height: 44px; margin: 5px;" src="/assets/images/shared/add-account.png" alt="">
                <p style="display: inline-block; width: 50%; margin: 5px;">Добави карта</p>
            </div>
            <div *ngIf="this.order?.paymentCard && this.order?.cardPayment" style="display: flex; align-items: center;">
                <img style="width: 44px; height: 44px; margin: 5px;" [src]="this.cardImg(this.order!.paymentCard!)" alt="">
                <p class="col-6"  style="padding-left: 0px; font-weight: 500; display: inline-block; width: 50%; margin: 5px;">{{ this.getCardDetail(this.order!.paymentCard!)  }}</p>
                <button (click)="this.cooseCard()" type="button" class="btn" style=" font-size: 14px; color: #007bff">Промени</button>
            </div>
        </div>
    </div>
    <div style="position: fixed; bottom: 35px; text-align: center; width: 90%; margin: auto; left: 5%;">
        <button type="button" [disabled]="!this.areDetalsFilled()" class="btn btn-primary" style="width: 100%; margin: auto; height: 45px;" (click)="this.continue()">Продължи</button>
    </div>
</div>

<ng-template #address let-modal>
    <div style="padding: 10px !important;">
        <h3 class="offcanvas-title" id="staticBackdropLabel" style="text-align: center; font-weight: 700; width: 100%;">{{ this.pageDetails().deliveryChoice }}</h3>
        <div
          (click)="!this.officeRestricted && this.toOffice(modal)"
          [class.text-muted]="this.officeRestricted"
          [style.pointer-events]="this.officeRestricted ? 'none' : 'auto'"
          [style.opacity]="this.officeRestricted ? 0.5 : 1"
        >
            <img style="width: 44px; height: 44px; margin: 5px;" src="/assets/images/shared/delivery-courier.png" alt="">
            <p style="display: inline-block; width: 50%; margin: 5px;">{{this.pageDetails().office}}</p>
            <small *ngIf="this.officeRestricted" class="d-block pl-3">
              Не е достъпно за продукти тип „Гуми“/„Палет“.
            </small>
        </div>
        <hr style="width: 90%; margin: auto; border: 1px solid #F5F7F8; opacity: 1; margin-top: 10px; margin-bottom: 20px;">
        <div (click)="this.toHome(modal)">
            <img style="width: 44px; height: 44px; margin: 5px;" src="/assets/images/shared/icon-address.png" alt="">
            <p style="display: inline-block; width: 50%; margin: 5px;">{{this.pageDetails().home}}</p>
        </div>
    </div>
</ng-template>

<ng-template #payments let-modal>
    <div style="padding: 10px !important;">
        <h3 class="offcanvas-title" id="staticBackdropLabel" style="text-align: center; font-weight: 700; width: 100%;">{{ this.pageDetails().paymentChoice }}</h3>
        <div (click)="this.toCard(modal)">
            <img style="width: 44px; height: 44px; margin: 5px;" src="/assets/images/shared/icon-card.png" alt="">
            <p style="display: inline-block; width: 50%; margin: 5px;">{{this.pageDetails().card}}</p>
        </div>
        <hr style="width: 90%; margin: auto; border: 1px solid #F5F7F8; opacity: 1; margin-top: 10px; margin-bottom: 20px;">
        <div
          (click)="!this.isCardOnlyPayment && this.toCod(modal)"
          [class.text-muted]="this.isCardOnlyPayment"
          [style.pointer-events]="this.isCardOnlyPayment ? 'none' : 'auto'"
          [style.opacity]="this.isCardOnlyPayment ? 0.5 : 1"
        >
            <img style="width: 44px; height: 44px; margin: 5px;" src="/assets/images/shared/icon-cash-on-delivery.png" alt="">
            <p style="display: inline-block; width: 50%; margin: 5px;">{{this.pageDetails().cod}}</p>
          <small *ngIf="this.isCardOnlyPayment" class="d-block pl-3">
            Наложен платеж не е достъпен за групови поръчки
            или за поръчки със стойност на продуктите над {{ this.cardOnlyThreshold }} лв.
          </small>
        </div>
    </div>
</ng-template>



